import Store from '@/store';
import RouteMeta from '../constants/route-meta';
import RouteNames from '../constants/route-names';
import StepUtilities from './step-utilities';

const getUnauthenticatedPath = to => {
  if (!Store.getters.isAuthenticated) {
    const { fullPath } = to;
    const { origin } = document.location;
    const confUrl = `${origin}${fullPath}`;
    return `${process.env.VUE_APP_HG_CLASSIC_URL}login.html?reDir=${confUrl}`;
  }
  return null;
};

const validateAccountManagement = (to, from) => {
  if (!to.meta
    || !to.meta[RouteMeta.AccountManagementStep]
    || !Store.getters.isAuthenticated) {
    return null;
  }
  const fromRouteIndex = StepUtilities.getStepIndexByRouteName(from.name);
  const emailStepIndex = StepUtilities.getStepIndexByRouteName(RouteNames.AppointmentCreateAccount);

  return fromRouteIndex > emailStepIndex
    ? RouteNames.AppointmentProperty
    : RouteNames.AppointmentContact;
};

const validateRequiresAuthentication = to => (to.meta
  && to.meta[RouteMeta.RequiresAuthentication]
  && !Store.getters.isAuthenticated
  ? RouteNames.AppointmentCreateAccount
  : null);

const validateRequiresPropertyStep = to => (to.meta
  && to.meta[RouteMeta.RequiresPropertyStep]
  && !Store.getters['Appointment/hasLocation']
  ? RouteNames.AppointmentProperty
  : null);

const validateRequiresScheduleStep = to => (to.meta
  && to.meta[RouteMeta.RequiresScheduleStep]
  && !Store.getters['Appointment/hasTime']
  ? RouteNames.AppointmentSchedule
  : null);

/**
 * Validate all Route-specific NavigationGuards
 *
 * @param {Route} to
 * @param {Route} from
 * @returns {string|null} RouteName constant
 */
const getNavigationGuardRedirectRoute = (to, from) => {
  // redirect to schedule step if missing data
  const scheduleRequiredRoute = validateRequiresScheduleStep(to);
  if (scheduleRequiredRoute) {
    return scheduleRequiredRoute;
  }

  // redirect to property step if missing data
  const propertyRequiredRoute = validateRequiresPropertyStep(to);
  if (propertyRequiredRoute) {
    return propertyRequiredRoute;
  }

  // redirect if unauthenticated
  const authenticationRequiredRoute = validateRequiresAuthentication(to);
  if (authenticationRequiredRoute) {
    return authenticationRequiredRoute;
  }

  // redirect if authenticated and on account management route
  const accountManagementRoute = validateAccountManagement(to, from);
  if (accountManagementRoute) {
    return accountManagementRoute;
  }

  return null;
};

export default {
  getNavigationGuardRedirectRoute,
  getUnauthenticatedPath,
  validateAccountManagement,
  validateRequiresAuthentication,
  validateRequiresPropertyStep,
  validateRequiresScheduleStep,
};
